import { MENUS } from '../constants/SideNavBarConstant';

const isSelectedMenu = (url: string, menuIndex: number, queryString: string): boolean => {
  let menuToHiglate;

  const querystring = new URLSearchParams(queryString);
  const source = querystring.get('source');
  if (source) {
    let sourceValue = source.split('|')[0];
    const sourceValueData = sourceValue.split('?')[0];
    sourceValue = sourceValueData.substring(1, sourceValue.length - 1);
    menuToHiglate = MENUS.indexOf(sourceValue);
  }

  if (menuToHiglate && menuToHiglate === menuIndex) return true;

  const v1 = MENUS[menuIndex].replace(/\//g, '');
  const v2 = url.replace(/\//g, '');
  return v1 === v2;
};

export { isSelectedMenu };
